import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import AdminLayout from '@/components/layout/AdminLayout';
import AdminCleaningPricingRules from './AdminCleaningPricingRules';
import AdminPricingRulesCoreConstruction from './AdminPricingRulesCoreConstruction';
import AdminElectricalPricingRules from './AdminElectricalPricingRules';
import AdminLandscapingPricingRules from './AdminLandscapingPricingRules';
import AdminFinishingInteriorsPricingRules from './AdminFinishingInteriorsPricingRules';
import AdminSpecialistCompliancePricingRules from './AdminSpecialistCompliancePricingRules';
import AdminWasteClearancePricingRules from './AdminWasteClearancePricingRules';
import AdminWindowsDoorsPricingRules from './AdminWindowsDoorsPricingRules';
import AdminKitchensBathroomsPricingRules from './AdminKitchensBathroomsPricingRules';
import AdminLocksSecurityPricingRules from './AdminLocksSecurityPricingRules';
import AdminPlumbingPricingRules from './AdminPlumbingPricingRules';
import AdminPropertyMaintenancePricingRules from './AdminPropertyMaintenancePricingRules';
import AdminRoofingPricingRules from './AdminRoofingPricingRules';
import './AdminPricingRulesPage.css';

type TabType = 
  | 'cleaning' 
  | 'blockwork' 
  | 'bricklaying' 
  | 'concrete'
  | 'electrical'
  | 'external-works'
  | 'finishing'
  | 'kitchens-bathrooms'
  | 'locks-security'
  | 'plumbing'
  | 'maintenance-handyman'
  | 'roofing'
  | 'specialist'
  | 'waste-clearance'
  | 'windows-doors';

export default function AdminPricingRulesPage() {
  const [activeTab, setActiveTab] = useState<TabType>('cleaning');

  return (
    <>
      <Helmet>
        <title>Pricing Rules - VireWire Admin</title>
      </Helmet>

      <AdminLayout>
        {/* Tabs Navigation */}
        <div className="pricing-tabs-nav">
          <button
            onClick={() => setActiveTab('cleaning')}
            className={`tab-button ${activeTab === 'cleaning' ? 'active' : ''}`}
          >
            Cleaning & Carpentry
          </button>
          <button
            onClick={() => setActiveTab('blockwork')}
            className={`tab-button ${activeTab === 'blockwork' ? 'active' : ''}`}
          >
            Blockwork
          </button>
          <button
            onClick={() => setActiveTab('bricklaying')}
            className={`tab-button ${activeTab === 'bricklaying' ? 'active' : ''}`}
          >
            Bricklaying
          </button>
          <button
            onClick={() => setActiveTab('concrete')}
            className={`tab-button ${activeTab === 'concrete' ? 'active' : ''}`}
          >
            Concrete Works
          </button>
          <button
            onClick={() => setActiveTab('electrical')}
            className={`tab-button ${activeTab === 'electrical' ? 'active' : ''}`}
          >
            Electrical & Smart Systems
          </button>
          <button
            onClick={() => setActiveTab('external-works')}
            className={`tab-button ${activeTab === 'external-works' ? 'active' : ''}`}
          >
            External Works & Landscaping
          </button>
          <button
            onClick={() => setActiveTab('finishing')}
            className={`tab-button ${activeTab === 'finishing' ? 'active' : ''}`}
          >
            Finishing & Interiors
          </button>
          <button
            onClick={() => setActiveTab('kitchens-bathrooms')}
            className={`tab-button ${activeTab === 'kitchens-bathrooms' ? 'active' : ''}`}
          >
            Kitchens & Bathrooms
          </button>
          <button
            onClick={() => setActiveTab('locks-security')}
            className={`tab-button ${activeTab === 'locks-security' ? 'active' : ''}`}
          >
            Locks & Security
          </button>
          <button
            onClick={() => setActiveTab('plumbing')}
            className={`tab-button ${activeTab === 'plumbing' ? 'active' : ''}`}
          >
            Plumbing, Heating & Gas
          </button>
          <button
            onClick={() => setActiveTab('maintenance-handyman')}
            className={`tab-button ${activeTab === 'maintenance-handyman' ? 'active' : ''}`}
          >
            Property Maintenance & Handyman
          </button>
          <button
            onClick={() => setActiveTab('roofing')}
            className={`tab-button ${activeTab === 'roofing' ? 'active' : ''}`}
          >
            Roofing
          </button>
          <button
            onClick={() => setActiveTab('specialist')}
            className={`tab-button ${activeTab === 'specialist' ? 'active' : ''}`}
          >
            Specialist & Compliance Services
          </button>
          <button
            onClick={() => setActiveTab('waste-clearance')}
            className={`tab-button ${activeTab === 'waste-clearance' ? 'active' : ''}`}
          >
            Waste & Clearance
          </button>
          <button
            onClick={() => setActiveTab('windows-doors')}
            className={`tab-button ${activeTab === 'windows-doors' ? 'active' : ''}`}
          >
            Windows, Doors & Glazing
          </button>
        </div>

        {/* Tab Content */}
        <div className="pricing-tabs-content">
          {activeTab === 'cleaning' && <AdminCleaningPricingRules isTabMode={true} />}
          {activeTab === 'blockwork' && <AdminPricingRulesCoreConstruction serviceType="core_const_blockwork" />}
          {activeTab === 'bricklaying' && <AdminPricingRulesCoreConstruction serviceType="core_const_bricklaying" />}
          {activeTab === 'concrete' && <AdminPricingRulesCoreConstruction serviceType="core_const_concrete" />}
          {activeTab === 'electrical' && <AdminElectricalPricingRules isTabMode={true} />}
          {activeTab === 'external-works' && <AdminLandscapingPricingRules isTabMode={true} />}
          {activeTab === 'finishing' && <AdminFinishingInteriorsPricingRules isTabMode={true} />}
          {activeTab === 'kitchens-bathrooms' && <AdminKitchensBathroomsPricingRules />}
          {activeTab === 'locks-security' && <AdminLocksSecurityPricingRules />}
          {activeTab === 'plumbing' && <AdminPlumbingPricingRules />}
          {activeTab === 'maintenance-handyman' && <AdminPropertyMaintenancePricingRules />}
          {activeTab === 'roofing' && <AdminRoofingPricingRules />}
          {activeTab === 'specialist' && <AdminSpecialistCompliancePricingRules />}
          {activeTab === 'waste-clearance' && <AdminWasteClearancePricingRules />}
          {activeTab === 'windows-doors' && <AdminWindowsDoorsPricingRules />}
        </div>
      </AdminLayout>
    </>
  );
}
